import React, { useState, useEffect } from 'react';
import styles from './singleInterview.module.scss';
import { Col, Row, Form, Card, Button, Alert, Accordion, Tab, Tabs } from 'react-bootstrap';
import CSSLoader from '../../../shared/cssLoader';
import { useParams, useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import * as yup from 'yup';
import { Document, Page, pdfjs } from 'react-pdf';
import Avatar from 'react-avatar';
import { getInterviewDetails } from '../../../../services/util/interviews';
import InterviewView from './InterviewView';
import ShareExternalMeetingDetailsModal from './shareExternalMeetingDetailsModal';
import { submitCandidateReviews, setInterviewerInterviewState, setCandidateInterviewState } from '../../../../services/util/interviews';
import { ThemeProvider } from 'styled-components';
import {
    MeetingProvider,
    darkTheme
} from 'amazon-chime-sdk-component-library-react';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';
import CustomNavbar from '../../customNavbar';
import { CustomDropdown } from '../../../shared/customDropdown';
import { CustomButton } from '../../../shared/customButton';
import { CustomConfirmationModal } from '../../../shared/customConfirmationModal';
import { CustomAlertBox } from '../../../shared/customAlertBox';
import CandidateCvView from '../../common/candidateCvView';
import CandidateCoverLetterView from '../../common/candidateCoverLetterView';
import StarRating from '../../../shared/rate';
import CandidateAnswersToCustomQuestionsView from '../../common/candidateAnswersToCustomQuestionsView';
import AddCandiateNoteModal from '../../common/addCandidateSpecialNoteModal';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const SingleInterview = (props) => {
    let [numPages, setNumPages] = useState(null);
    let [pageNumber, setPageNumber] = useState(1);
    let [isLoading, setLoading] = useState(false);
    let [isLeaving, setLeaving] = useState(false);
    let [emptyCommentsError, setEmptyCommentsError] = useState(false);
    let [emptyMarksError, setEmptyMarksError] = useState(false);
    let [emptyOverallMarksError, setEmptyOverallMarksError] = useState(false);
    let [outOfRangeOverallMarksError, setOutOfRangeOverallMarksError] = useState(false);
    const [isSubmit, setSubmit] = useState(false)
    const [defaultScale, setDefaultScale] = useState(1.6);
    const [defaultScalePrecentage, setScalePrecentage] = useState(100);
    const [isModalOpen, setModalOpen] = useState(false);
    const [isIAttendModalOpen, setIsIAttendModalOpen] = useState(false);
    const [isCandidateAttendModalOpen, setIsCandidateAttendModalOpen] = useState(false);
    const [showcreateInterviewEventModal, setShowCreateInterviewModal] = useState(false);
    const [reviewCriteriaRating, setReviewCriteriaRating] = useState([]);
    const [isCandidateTryToJoin, setCandidateTryToJoin] = useState(false);
    const [isHostApprovedCandiate, setHostApprovedCandiate] = useState(false);

    const moment = require('moment');

    let [isExternalMeetingEnabled, setIsExternalMeetingEnabled] = useState(false);
    let [isURLLoading, setURLLoading] = useState(false);
    let [dropdownError, setDropDownError] = useState();
    let [marks, setMarks] = useState(-1);
    let [state, setState] = useState({
        comments: []
    });
    let [accordionIcon, setAccordionIcon] = useState(true);
    let [candidateValues, setCandidateValues] = useState({
        candidate_id: '',
        candidate_name: '',
        candidate_email: '',
        candidate_mobile_country_code: '',
        candidate_mobile_number: '',
        candidate_cv_url: '',
        candidate_cover_letter: null,
        hiring_position: '',
        evaluation_criteria: '',
        interview_type: null,
        interview_location_address: null,
        assigned_reviewers: [],
        schedule: {
            date_time: null,
            time_zone: null
        },
        custom_question_answers: [],
        review_criteria: [],
        is_interview_started_notified_email_received: ''
    });
    let [calOverallMark, setCalOverallMark] = useState(null);
    let [externalMeetingModalData, setExternalMeetingModalData] = useState({
        candidate_name: '',
        candidate_email: '',
        assigned_reviewers: [],
        schedule: {
            date_time: null,
            time_zone: null
        }
    });

    let [externalMeetingData, setExternalMeetingData] = useState({
        external_meeting_url: '',
        external_meeting_details: '',
        external_meeting_shared_by: '',
        is_shared_external_meeting_during_inbuilt_video_interview:''
    });

    let [onlineMeetingData, setOnlineMeetingData] = useState({
        online_meeting_url: '',
        online_meeting_shared_by: ''
    });


    const [cvObject, setCVObject] = useState({ url: null })
    let { id } = useParams();
    let history = useNavigate();
    const options = {
        cMapUrl: 'cmaps/',
        cMapPacked: true,
    };
    const breadcrumb = [
        {
            pathaddress: '/app/company/interviews',
            pathname: 'Interviews',
            isActive: false,
            key: 2 + 'interviews'
        },
        {
            pathaddress: '',
            pathname: `${candidateValues.candidate_name}'s Interview`,
            isActive: true,
            key: 3 + candidateValues.candidate_name
        }
    ]

    const breacrumbText = 'Conduct the interview and rate the candidate using star ratings. If the overall score is higher than the passing threshold, the candidate will move forward.'

    //dropdown values
    const dropValue = [
        {
            label: '--SELECT--',
            value: -1,
        },
        {
            label: '1',
            value: 1,
        },
        {
            label: '2',
            value: 2,
        },
        {
            label: '3',
            value: 3,
        },
        {
            label: '4',
            value: 4,
        },
        {
            label: '5',
            value: 5,
        },
        {
            label: '6',
            value: 6,
        },
        {
            label: '7',
            value: 7,
        },
        {
            label: '8',
            value: 8,
        },
        {
            label: '9',
            value: 9,
        },
        {
            label: '10',
            value: 10,
        },
    ]
    const schema = yup.object({
        comments: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'),
    });

    function nextPage() {
        if (pageNumber !== numPages) {
            setPageNumber(prevState => prevState + 1);
        }
    }



    function prevPage() {
        if (pageNumber !== 1) {
            setPageNumber(prevState => prevState - 1);
        }
    }

    const zoomin = () => {
        if (defaultScale < 2) {
            setDefaultScale(defaultScale + 0.2);
            setCvViewprecentage((defaultScale + 0.2));
        }

    }
    const zoomout = () => {
        if (defaultScale > 1.0000000000000002) {
            setDefaultScale(defaultScale - 0.2);
            setCvViewprecentage((defaultScale - 0.2));
        }
    }


    const setCvViewprecentage = (value) => {
        //check scale value and change precentage value according to scale value
        setScalePrecentage(value === 2 ? 150 : value === 1.8 ? 125 : value === 1.6 ? 100 : value === 1.4000000000000001 ? 75 : value === 1.2000000000000002 ? 50 : value === 1.0000000000000002 ? 25 : 0)
    }

    //on pdf load success
    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        setNumPages(nextNumPages);
    }

    //on adding comments function
    const onSubmit = async (values, { resetForm }) => {
        setEmptyCommentsError(false)
        addComment(values.comments);
        resetForm({ comments: '' });
    }

    //add comment function
    function addComment(item) {
        setState(state => ({
            comments: [...state.comments, item]
        }));
    }
    //remove comment function
    function removeComment(item) {
        let array = [state.comments];
        if (item !== -1) {
            array[0].splice(item, 1);
            setState({
                comments: array[0]
            })
        }
    }


    //submit values function
    async function submitValues() {
        if ((calOverallMark !== null || marks !== -1)) {
            const reviewCriteriaData = [];
            for (let key in candidateValues.review_criteria) {
                for (let keys in reviewCriteriaRating) {
                    if (candidateValues.review_criteria[key].label === reviewCriteriaRating[keys].label) {
                        if (reviewCriteriaRating[keys].rate !== 0) {
                            const newOverallRating = {
                                _id: candidateValues.review_criteria[key]._id,
                                label: candidateValues.review_criteria[key].label,
                                rate: reviewCriteriaRating[keys].rate,
                            }
                            reviewCriteriaData.push(newOverallRating)
                        }
                    }
                }
            }
            setSubmit(true)
            //convert marks to 100% and assign to score
            let score = calOverallMark !== null ? calOverallMark : (marks * 10).toFixed(1);
            let respond = await submitCandidateReviews(id, score, state.comments, reviewCriteriaData ? reviewCriteriaData : null)
            if (respond.success === true) {
                props.GetTaskValues();
                setSubmit(false)
                history('/company/interviews');
            } else {
                setSubmit(false)
            }
        } else {
            if (marks === -1) {
                setEmptyMarksError(true)
            }
            if (calOverallMark === null) {
                setEmptyOverallMarksError(true);
            }
        }
    }

    function checkValidationAndOpenModal() {
        //using "marks" for older pipes and "overallmarks" for more recent pipelines
        //check whether comments and marks(calOverallMark or marks) null
        if (state.comments.length >= 0 && ((calOverallMark > -1 && calOverallMark < 101 && calOverallMark != "" && calOverallMark !== null) || marks !== -1)) {
            setOutOfRangeOverallMarksError(false);
            setModalOpen(true);
        }
        else {
            if (marks === -1) {
                setEmptyMarksError(true)
            }
            if (calOverallMark < 0 || calOverallMark > 100 || calOverallMark === null || calOverallMark == "") {
                setOutOfRangeOverallMarksError(true)
            }
        }
    }

    //submit interviewer didn't attened
    async function submitInterviewerInterviewState() {
        setSubmit(true)
        let respond = await setInterviewerInterviewState(id, -1)
        if (respond.success === true) {
            props.GetTaskValues();
            setSubmit(false)
            history('/company/interviews');
        } else {
            setSubmit(false)
        }

    }

    //submit candidate didn't attened
    async function submitCandidateInterviewState() {
        setSubmit(true)
        let respond = await setCandidateInterviewState(id, -1)
        if (respond.success === true) {
            props.GetTaskValues();
            setSubmit(false)
            history('/company/interviews');
        } else {
            setSubmit(false)
        }

    }

    const changeAccordionIcon = () => {
        setAccordionIcon(!accordionIcon)
    }

    //load user values
    const getSingleInterviewDetails = async () => {
        setLoading(true)
        let respond = await getInterviewDetails(id);
        if (respond.success === true) {

            let assigned_reviewers = []
            for (let index = 0; index < respond.data.assigned_reviewers.length; index++) {
                assigned_reviewers.push({ email: respond.data.assigned_reviewers[index].email, name: respond.data.assigned_reviewers[index].first_name + ' ' + respond.data.assigned_reviewers[index].last_name })
            }
            let candidate_data = {
                candidate_id: respond.data.candidate_id,
                candidate_name: respond.data.candidate_name,
                candidate_email: respond.data.candidate_email,
                candidate_mobile_country_code: respond.data.candidate_mobile_country_code,
                candidate_mobile_number: respond.data.candidate_mobile_number,
                candidate_cv_url: respond.data.candidate_cv_url,
                candidate_cover_letter: respond.data.candidate_cover_letter_url,
                hiring_position: respond.data.hiring_position,
                evaluation_criteria: respond.data.evaluation_criteria,
                interview_type: respond.data.interview_type,
                interview_location_address: respond.data.interview_location_address, 
                assigned_reviewers: assigned_reviewers,
                minimum_pass_score: respond.data.minimum_pass_score,
                pipeline_name: respond.data.pipeline_name,
                review_criteria: respond.data.review_criteria,
                candidate_photo_url: respond.data.candidate_photo_url,
                schedule: {
                    date_time: respond.data.schedule.date_time,
                    time_zone: respond.data.schedule.time_zone
                },
                custom_question_answers: respond.data.custom_question_answers,
                is_interview_started_notified_email_received : respond.data.is_interview_started_notified_email_received,

            }

            let external_meeting_modal_data = {
                session_id: id,
                candidate_name: respond.data.candidate_name,
                candidate_email: respond.data.candidate_email,
                assigned_reviewers: assigned_reviewers,
                schedule: {
                    date_time: respond.data.schedule.date_time,
                    time_zone: respond.data.schedule.time_zone
                }
            }
            setIsExternalMeetingEnabled(respond.data.is_external_meeting_enabled)

            if (respond.data.is_external_meeting_enabled) {
                setIsExternalMeetingEnabled(true)
                setExternalMeetingData({
                    external_meeting_url: respond.data.external_meeting_details.external_meeting_url,
                    external_meeting_details: respond.data.external_meeting_details.external_meeting_details,
                    external_meeting_shared_by: respond.data.external_meeting_details.external_meeting_shared_by,
                    is_shared_external_meeting_during_inbuilt_video_interview: respond.data.external_meeting_details.is_shared_external_meeting_during_inbuilt_video_interview ? respond.data.external_meeting_details.is_shared_external_meeting_during_inbuilt_video_interview: false,
                });
            }
            if (respond.data.is_online_meeting_enabled) {
                setOnlineMeetingData({
                    online_meeting_url: respond.data.online_meeting_details.online_meeting_url,
                    online_meeting_shared_by: respond.data.online_meeting_details.online_meeting_shared_by
                });
            }
            setCandidateValues(candidate_data)
            setExternalMeetingModalData(external_meeting_modal_data)
            await setCVObject({
                url: respond.data.candidate_cv_url
            })
            setLoading(false)
        } else {
            setLoading(false)
            history('/company/interviews')
        }
    }

    const showCreateInterviewEventModal = () => {
        setShowCreateInterviewModal(true)
    }

    const closeModal = () => {
        setShowCreateInterviewModal(false)
    }

    useEffect(() => {
        getSingleInterviewDetails();
        return () => {
            setLeaving(true)
            setLoading(false)
        };
    }, [id]);

    useEffect(() => {
        props.toggleInterviewView(true);
        let pageHit = '/app/company/interview-review';
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
        ReactGA.send({ hitType: "pageview", page: pageHit});
    }, [])

    function viewCandidate(val) {
        let path = `/app/company/candidate`;
        let search = 'cid=' + val;

        const url = `${path}?${search}`;
        window.open(url);
    }

    const handleRatingChange = (id, rating, label) => {
        setOutOfRangeOverallMarksError(false);
        let data = {
            rate: rating,
            label: label,
        }
        setReviewCriteriaObj(data);
    };
    const setReviewCriteriaObj = (data) => {
        const reviewCriteriaList = [...reviewCriteriaRating];
        if (reviewCriteriaRating.length === 0) {
            setReviewCriteriaRating(current => ([...current, data]));
        }
        else {
            let reviewRating = reviewCriteriaList.find(reviewCriteriaRating => reviewCriteriaRating.label === data.label);
            if (reviewRating) {
                reviewRating.rate = data.rate === null ? 0 : data.rate;
                setReviewCriteriaRating(reviewCriteriaList);
            }
            else {
                setReviewCriteriaRating(current => ([...current, data]));
            }
        }
    }

    let [specialNoteModalOpen, setSpecialNoteModalOpen] = useState(false);

    const openSpecialNoteModal = () => {
        setSpecialNoteModalOpen(true);
    }

    const closeSpecialNoteModal = () => {
        setSpecialNoteModalOpen(false);
    }

    useEffect(() => {
        calculateMarks();
    }, [reviewCriteriaRating])

    const calculateMarks = () => {
        var results = 0;
        var addition = 0;
        var divider = 0;
        for (let key in reviewCriteriaRating) {
            if (reviewCriteriaRating[key].rate !== 0) {
                addition += reviewCriteriaRating[key].rate;
                divider += 1;
            }
        }
        if (addition !== 0) {
            results = (addition / (divider * 5)) * 100;
        }
        setCalOverallMark(results === 0 ? null : results.toFixed(1))
    };

    return (
        <div className={styles.singleInterviewBody}>
            <Helmet>
                <title>Interview | HireTrace</title>
            </Helmet>
            {isLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>

                    {/* submit result alert confirmation start */}
                    <CustomConfirmationModal
                        show={isModalOpen}
                        confirmationType='success'
                        cancelIconclick={() => setModalOpen(false)}
                        onSecondaryBtnClick={() => setModalOpen(false)}
                        onPrimaryBtnClick={submitValues}
                        isSecondaryBtnDisabled={isSubmit === true ? true : false}
                        isPrimaryBtnDisabled={isSubmit === true ? true : false}
                        primaryBtnBackSideIcon={isSubmit === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage="Please make sure you have entered the score and all feedback comments. Because after submitting, you cannot change them. Also, this interview will be removed from your assigned Interview list."
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="successBtn"
                        primaryBtnLabel="Yes, Submit!"
                    />
                    {/* submit result alert confirmation end */}

                    {/* submit i didn't attenend alert confirmation start */}
                    <CustomConfirmationModal
                        show={isIAttendModalOpen}
                        confirmationType='danger'
                        cancelIconclick={() => setIsIAttendModalOpen(false)}
                        onSecondaryBtnClick={() => setIsIAttendModalOpen(false)}
                        onPrimaryBtnClick={submitInterviewerInterviewState}
                        isSecondaryBtnDisabled={isSubmit === true ? true : false}
                        isPrimaryBtnDisabled={isSubmit === true ? true : false}
                        primaryBtnBackSideIcon={isSubmit === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage="You are submitting your response as “I Didn't Attend”"
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="dangerBtn"
                        primaryBtnLabel="Yes, Submit!"
                    />
                    {/* submit i didn't attenend alert confirmation end */}

                    {/* submit candidate didn't attenend alert confirmation start */}
                    <CustomConfirmationModal
                        show={isCandidateAttendModalOpen}
                        confirmationType='danger'
                        cancelIconclick={() => setIsCandidateAttendModalOpen(false)}
                        onSecondaryBtnClick={() => setIsCandidateAttendModalOpen(false)}
                        onPrimaryBtnClick={submitCandidateInterviewState}
                        isSecondaryBtnDisabled={isSubmit === true ? true : false}
                        isPrimaryBtnDisabled={isSubmit === true ? true : false}
                        primaryBtnBackSideIcon={isSubmit === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage="You are submitting your response as “Candidate Didn’t Attend”"
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="dangerBtn"
                        primaryBtnLabel="Yes, Submit!"
                    />
                    {/* submit candidate didn't attenend alert confirmation end */}
                    {
                        showcreateInterviewEventModal &&
                        <ShareExternalMeetingDetailsModal showModal={showcreateInterviewEventModal} externalMeetingModalData={externalMeetingModalData} handleClose={closeModal} />
                    }
                    {/* open add note modal */}
                    {specialNoteModalOpen &&
                        <AddCandiateNoteModal showModal={specialNoteModalOpen} handleClose={() => setSpecialNoteModalOpen(false)} candidateID={candidateValues.candidate_id} />
                    }
                    {/* close add note modal */}
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} breacrumbText= {breacrumbText}/>
                    </div>


                    {/* candidate review details */}
                    <Row>
                        <Col>
                            <div className={styles.reviewDetails}>
                                <Row>
                                    <Col md={1} lg={1} xl={1} className={styles.candidatePhoto}>
                                        <Avatar src={candidateValues.candidate_photo_url} name={candidateValues.candidate_name} size="90" round={false} />
                                    </Col>
                                    <Col md={11} lg={11} xl={11} className={styles.candidateDetails}>
                                        <Row>
                                            <Col sm={5}>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Name : </span><span className={styles.reviewDetailsValue} id="adminPanel_interviews_singleInterview_candidateNameId">{candidateValues.candidate_name}</span> <i onClick={() => viewCandidate(candidateValues.candidate_id)} class="fas fa-external-link-alt ml-1S" id={styles.openInNewtabIcon}></i> </p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Email : </span><span className={styles.reviewDetailsValue} id="adminPanel_interviews_singleInterview_candidateEmailId">{candidateValues.candidate_email}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Mobile : </span><span className={styles.reviewDetailsValue} id="adminPanel_interviews_singleInterview_candidateMobileId">{`(${candidateValues.candidate_mobile_country_code}) ${candidateValues.candidate_mobile_number}`}</span></p>
                                            </Col>
                                            <Col sm={5}>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Pipeline : </span><span className={styles.reviewDetailsValue} id="adminPanel_interviews_singleInterview_pipelineNameId">{candidateValues.pipeline_name}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Position : </span><span className={styles.reviewDetailsValue} id="adminPanel_interviews_singleInterview_positionId">{candidateValues.hiring_position}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Passing Threshold : </span><span className={styles.reviewDetailsValue}>{candidateValues.minimum_pass_score}%</span></p>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Interviewers : </span>
                                                    {candidateValues.assigned_reviewers.map((value) => (
                                                        <span className={styles.reviewDetailsValue} id="adminPanel_interviews_singleInterview_interviewersEmailId">{value.email} &nbsp; &nbsp; &nbsp;</span>
                                                    ))}
                                                </p>

                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Review Criteria : </span><span className={styles.reviewDetailsValue}>{candidateValues.evaluation_criteria}</span></p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>

                        </Col>
                    </Row>
                    <Row className={styles.bodyRow}>

                        {/* left side of the view */}
                        <Col md={7} lg={8} xl={9} className={styles.leftSideRow}>

                            {/* internal meeting feature */}
                            {candidateValues.interview_type === 0 &&
                                (
                                    <div>
                                        <div>
                                            <p className={styles.onlineMeetingDetailsTopic}>Interview Details</p>
                                            <hr />
                                        <div>
                                            <div className={styles.onlineMeetingDetailsRow}>
                                                <Row>
                                                    <Row>
                                                        <p className={styles.interviewDetailsItem}><span className={styles.onlineMeetingDetailsLabel}>Mode : </span>&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.scheduleDetailsValue}>Online Video Interview using HireTrace inbuilt tool (see below)</span></p>
                                                    </Row>
                                                    <Row>
                                                        <p className={styles.interviewDetailsItem}><span className={styles.onlineMeetingDetailsLabel}>Schedule : </span>&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.scheduleDetailsValue}>{moment.tz(candidateValues.schedule.date_time,candidateValues.schedule.time_zone).format('ddd, MMM D, YYYY - hh:mm A')}</span>&nbsp;<span className={styles.scheduleDetailsValue}>({candidateValues.schedule.time_zone})</span></p>
                                                    </Row>
                                                    </Row>
                                                </div>
                                            </div>


                                    </div>
                                    <div className={styles.interviewBox}>
                                        <ThemeProvider theme={darkTheme}>
                                            <MeetingProvider>
                                                <InterviewView assigned_reviewers={candidateValues.assigned_reviewers} candidateName={candidateValues.candidate_name} candidateEmail={candidateValues.candidate_email} isInterviewStartedNotifiedEmailReceived={candidateValues.is_interview_started_notified_email_received} isLeaving={isLeaving} sessionID={id} sheduleTime={candidateValues.schedule} />
                                            </MeetingProvider>
                                        </ThemeProvider>
                                    </div>
                                    <div className='d-flex align-items-end flex-column bd-highlight mt-3 mr-1'>
                                        <p className={styles.thirdPartyLink} onClick={() => { showCreateInterviewEventModal() }}>Any issues when using the video tool?</p>
                                    </div>

                                </div>)
                            }
                            {/* external meeting details (if internal interview mode had issues) */}
                            {candidateValues.interview_type === 2 && isExternalMeetingEnabled &&
                                (<div className={styles.externalMeetingDetailsOuterBox}>
                                {externalMeetingData.is_shared_external_meeting_during_inbuilt_video_interview &&
                                    <CustomAlertBox
                                        alertType='warningAlert'
                                        alertBodyText={`An interviewer (${externalMeetingData.external_meeting_shared_by}) has shared an external video meeting link to conduct the interview. Please use below "External Meeting Details" connect with other interviewers and the candidate.`}
                                    />
                                }
                                <div className={styles.externalMeetingDetailsBox}>
                                    <p className={styles.externalMeetingDetailsTopic}>External Meeting Details</p>
                                    <span className={styles.externalMeetingDetailsDescription}>Use below meeting url to connect with the candidate and other interviewers.</span>
                                    <hr />
                                    <Row>
                                        <div>
                                            <p className={styles.externalMeetingDetailsLabel}>Connect URL : &nbsp;
                                                <span>
                                                    {externalMeetingData.external_meeting_url ?
                                                        <a target="_blank" className={styles.externalMeetingDetailsLinkValue} href={externalMeetingData.external_meeting_url} rel="noreferrer"> {externalMeetingData.external_meeting_url} &nbsp;<i class="fas fa-external-link-alt ml-2"></i> </a>
                                                        :
                                                        <p className={styles.externalMeetingDetailsValue}>Not available</p>
                                                    }
                                                </span>
                                            </p>
                                        </div>
                                        {externalMeetingData.external_meeting_details &&
                                            <div>
                                                <p className={styles.externalMeetingDetailsLabel}>Meeting Description :&nbsp;
                                                    <span>
                                                        <span className={styles.externalMeetingDetailsValue}>{externalMeetingData.external_meeting_details}</span>
                                                    </span>
                                                </p>
                                            </div>
                                        }
                                    </Row>

                                </div>

                                </div>)
                            }
                            
                            {candidateValues.interview_type !== 2 && candidateValues.interview_type !== 0 && (
                                <div>
                                    <p className={styles.onlineMeetingDetailsTopic}>Interview Details</p>
                                    <hr />
                                    <div>
                                        <div className={styles.onlineMeetingDetailsRow}>
                                            <Row>
                                                <Row>
                                                    <p className={styles.interviewDetailsItem}><span className={styles.onlineMeetingDetailsLabel}>Mode : </span>&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.scheduleDetailsValue}>In-person face to face interview</span></p>
                                                </Row>
                                                <Row>
                                                    <p className={styles.interviewDetailsItem}><span className={styles.onlineMeetingDetailsLabel}>Schedule : </span>&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.scheduleDetailsValue}>{moment.tz(candidateValues.schedule.date_time,candidateValues.schedule.time_zone).format('ddd, MMM D, YYYY - hh:mm A')}</span>&nbsp;<span className={styles.scheduleDetailsValue}>({candidateValues.schedule.time_zone})</span></p>
                                                </Row>
                                                <Row>
                                                    <p className={styles.interviewDetailsItem}><span className={styles.onlineMeetingDetailsLabel}>Location : </span>&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.scheduleDetailsValue}>{candidateValues.interview_location_address}</span></p>
                                                </Row>
                                            </Row>
                                        </div>
                                    </div>


                                </div>
                            )}

                            {/* view cv , cover letter and Custom Questions  */}
                            <Tabs
                                defaultActiveKey="cv"
                                id="controlled-tab-example"
                                className={styles.tabGroup}
                            >
                                <Tab eventKey="cv" title="CV" tabClassName={styles.tabItem} >

                                    <CandidateCvView candidateValues={candidateValues} stepId={id} cvURL={candidateValues.candidate_cv_url} candidateID={candidateValues.candidate_id}
                                    />
                                </Tab>
                                {candidateValues.candidate_cover_letter ? <Tab eventKey="CoverLetter" title="Cover Letter" tabClassName={styles.tabItem} >
                                    <CandidateCoverLetterView candidateValues={candidateValues} stepId={id} coverLetterURL={candidateValues.candidate_cover_letter} candidateID={candidateValues.candidate_id} />
                                </Tab> : null}
                                {candidateValues.custom_question_answers && candidateValues.custom_question_answers.length > 0 ?
                                    <Tab eventKey="customQuestions" title="Custom Questions" tabClassName={styles.tabItem} >
                                        <CandidateAnswersToCustomQuestionsView candidateValues={candidateValues} />
                                    </Tab> : null}
                            </Tabs>

                        </Col>
                        <Col className={styles.reviewSubmissionColumn} md={5} lg={4} xl={3}>
                            <Card className={styles.reviewSubmissionCard}>
                                <Card.Header className={styles.reviewSubmissionCardHeader}>
                                    <div className={styles.reviewSubmissionCardheaderDetails}>
                                        <p className={styles.reviewSubmissionCardHeaderTopic}>Submit Feedback</p>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <div>
                                        <div>
                                            <div className={styles.addNoteDiv}>
                                                <p className={styles.noteValue} onClick={() => openSpecialNoteModal()}>Add special note</p>
                                            </div>
                                            {candidateValues.review_criteria.length ?
                                                <div className='mt-n4'>
                                                    <p className={styles.reviewFeedbackLabel}>Feedback</p>
                                                    {candidateValues.review_criteria.map((item, i) => (
                                                        <Card className={styles.reviewFeedbackBox} key={i}>

                                                            <Card.Body className={styles.reviewFeedbackBoxBody}>
                                                                <span className={styles.reviewFeedbackInnerBox}>
                                                                    <span className={styles.reviewFeedbackValue}>{item.label}</span>
                                                                    <span className={styles.reviewFeedbackStars}><StarRating className="mr-4" disabled={false} id={i} onRatingChange={(reviewCriteriaRating) => { handleRatingChange(i, reviewCriteriaRating, item.label); setOutOfRangeOverallMarksError(false) }} /></span>
                                                                </span>
                                                            </Card.Body>
                                                        </Card>
                                                    ))
                                                    }
                                                    <p className={styles.reviewFeedbackOverallScore}><span className={styles.reviewFeedbackOverallScoreLabel}>Overall Marks : </span><span className={styles.reviewFeedbackOverallScoreLabelValue}>{(calOverallMark && calOverallMark > 0) ? calOverallMark : 0}%</span></p>

                                                    {(outOfRangeOverallMarksError === true) &&
                                                        <p className={styles.reviewErrorMsg}>  You have to give at least one star rating.</p>
                                                    }
                                                </div>
                                                :
                                                <div>
                                                    <Formik
                                                        initialValues={{ marks: marks }}>

                                                        {({
                                                            values,
                                                            errors,
                                                            setFieldValue,
                                                            handleSubmit,
                                                            submitCount
                                                        }) => (
                                                            <div>
                                                                <Form noValidate onSubmit={handleSubmit}>
                                                                    <CustomDropdown
                                                                        label="Overall Marks"
                                                                        classLabel="defaultLabel"
                                                                        labelDesc="Score candidate 1 to 10. 1 is lowest, 10 is highest."
                                                                        controlId="marks"
                                                                        name="marks"
                                                                        value={values.marks}
                                                                        handleOnChange={(e) => { setFieldValue('marks', e.target.value); setMarks(parseInt(e.target.value)) }}
                                                                        dropdownValues={dropValue}
                                                                        errorMessage={dropdownError}
                                                                        onFocus={() => setEmptyMarksError(false)}
                                                                        isInvalid={emptyMarksError}
                                                                    />
                                                                </Form>
                                                                {(emptyMarksError === true && marks === -1) &&
                                                                    <p className={styles.reviewErrorMsg}> Select Valid Mark.</p>
                                                                }
                                                            </div>
                                                        )}
                                                    </Formik>
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <Formik
                                        validationSchema={schema}
                                        onSubmit={(values, resetForm) => onSubmit(values, resetForm)}
                                        initialValues={{}}>

                                        {({
                                            values,
                                            errors,
                                            setFieldValue,
                                            handleChange,
                                            handleSubmit,
                                            submitCount,
                                            resetForm
                                        }) => (
                                            <div>
                                                <Form noValidate onSubmit={handleSubmit}>
                                                    <Form.Group controlId="comments">
                                                        <Form.Label className={styles.reviewCommentsLabel}>Comments</Form.Label>
                                                        <Form.Control as="textarea" name="comments" value={values.comments || ''} onChange={(e) => { setFieldValue('comments', e.target.value); }} rows={3} className={styles.reviewCommentsBox} isInvalid={errors.comments || emptyCommentsError} onFocus={() => setEmptyCommentsError(false)} />
                                                        <p className={styles.reviewErrorMsg}>{errors.comments}</p>
                                                    </Form.Group>

                                                    <div className={styles.commentAddBtn}>
                                                        <CustomButton
                                                            buttonType="submit"
                                                            type="secondaryBtn"
                                                            label="Add Comment"
                                                            name="addCommentBtn"
                                                            handleClick={handleChange}
                                                        />
                                                    </div>
                                                    <div className='mb-1 pb-1'>
                                                        {
                                                            state.comments.map((item, i) => (
                                                                <Row className='m-0 p-1'>
                                                                    <Col sm={11} className='m-0 p-0'>
                                                                        <Card className={styles.reviewCommentBox} key={i}>
                                                                            <Card.Body className={styles.reviewCommentBoxBody}>
                                                                                <span className={styles.reviewCommentsInnerBox}>
                                                                                    <span className={styles.reviewCommentValue}>{item}</span>
                                                                                </span>
                                                                            </Card.Body>
                                                                        </Card>
                                                                    </Col>
                                                                    <Col sm={1} className={styles.reviewCommentSecondCol}>
                                                                        <span className={styles.cancelIconDiv} onClick={() => removeComment(i)} key={(props.keyValue) + 1}>
                                                                            <svg className={styles.cancelIcon} width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <g id="trash-01">
                                                                                    <path id="Icon" d="M13.3333 5.49999V4.83332C13.3333 3.8999 13.3333 3.43319 13.1517 3.07667C12.9919 2.76307 12.7369 2.5081 12.4233 2.34831C12.0668 2.16666 11.6001 2.16666 10.6667 2.16666H9.33333C8.39991 2.16666 7.9332 2.16666 7.57668 2.34831C7.26308 2.5081 7.00811 2.76307 6.84832 3.07667C6.66667 3.43319 6.66667 3.8999 6.66667 4.83332V5.49999M8.33333 10.0833V14.25M11.6667 10.0833V14.25M2.5 5.49999H17.5M15.8333 5.49999V14.8333C15.8333 16.2335 15.8333 16.9335 15.5608 17.4683C15.3212 17.9387 14.9387 18.3212 14.4683 18.5608C13.9335 18.8333 13.2335 18.8333 11.8333 18.8333H8.16667C6.76654 18.8333 6.06647 18.8333 5.53169 18.5608C5.06129 18.3212 4.67883 17.9387 4.43915 17.4683C4.16667 16.9335 4.16667 16.2335 4.16667 14.8333V5.49999" stroke="#B42318" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                                </g>
                                                                            </svg>
                                                                        </span>
                                                                    </Col>
                                                                </Row>
                                                            ))
                                                        }
                                                    </div>

                                                </Form>
                                            </div>
                                        )}
                                    </Formik>


                                    <div className={styles.submitButtonGroupWrapper}>
                                        <div>
                                            <CustomButton
                                                buttonType="submit"
                                                type="primaryBtn"
                                                label="Submit"
                                                id="adminPanel_interviews_singleInterview_submitBtnId"
                                                disabled={isSubmit === true ? true : false}
                                                handleClick={checkValidationAndOpenModal}
                                            />

                                        </div>

                                        <div className='mt-2'>
                                            <CustomButton
                                                buttonType="button"
                                                type="warningBtn"
                                                label="I didn’t attend"
                                                id="adminPanel_interviews_singleInterview_iDidntAttendBtnId"
                                                disabled={state.comments.length > 0 || isSubmit === true ? true : false}
                                                handleClick={() => setIsIAttendModalOpen(true)}
                                            />
                                        </div>

                                        <div className='mt-2'>
                                            <CustomButton
                                                buttonType="button"
                                                type="warningBtn"
                                                id="adminPanel_interviews_singleInterview_candidateDidntAttendBtnId"
                                                label="Candidate didn’t attend"
                                                disabled={state.comments.length > 0 || isSubmit === true ? true : false}
                                                handleClick={() => setIsCandidateAttendModalOpen(true)}
                                            />
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>)
            }
        </div >
    )
}

export default SingleInterview;
